var l = typeof global == "object" && global && global.Object === Object && global;
const e = l;
export {
  e as default
};
